import moment from 'moment';

// Shared by Bankhändelser, Skattekonto and the banking sub-components.
export function formatCurrency(amount) {
    return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(amount);
}

export function formatDate(value) {
    if (!value) return '-';
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const m = moment(value);
    return m.isValid() ? m.format('YYYY-MM-DD') : String(value);
}
